<div class="modal-image-header">
  <slot />
</div>

<style lang="scss">
  .modal-image-header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 50px 0 30px;
    background-color: $color-medium-gray;
    width: 100%;
    border-radius: 13px 13px 0 0;
  }
  @include mobile {
    .modal-image-header {
      border-radius: 0;
    }
  }
</style>
